<script setup>
  import {computed} from "vue";

  import ComponentAlert from "@components/Alerts/Alert.vue";
  import ComponentInput from "@components/Inputs/Input.vue";
  import ComponentTextarea from "@components/Textarea/Textarea.vue";
  import PatientinputComponentStep from "@pages/Patientinput/Components/Step.vue";
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PatientinputComponentStepEnd",
  });

  const props = defineProps({
    form: {
      type: Object,
      required: true,
    },
  });

  defineEmits(["navigate"]);

  const allFieldsValid = computed(() => {
    return !!props.form.contactdata.name;
  });
</script>

<template>
  <PatientinputComponentStep title="Fast fertig" :test-id="getTestId()">
    <template v-if="form.hasErrors">
      <ComponentAlert type="error" :test-id="getTestId('end-step')">
        <p>Beim Absenden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.</p>
      </ComponentAlert>
    </template>

    <h2 class="text-xl font-semibold">Wie können wir Sie erreichen?</h2>

    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <ComponentInput
        v-model="form.contactdata.name"
        type="text"
        autocomplete="name"
        label="Name *"
        large
        :test-id="getTestId('end-step-name')"
      />

      <ComponentInput
        v-model="form.contactdata.telephone"
        class="col-start-1"
        type="tel"
        autocomplete="tel"
        label="Telefonnummer"
        large
        :test-id="getTestId('end-step-telephone')"
      />

      <ComponentInput
        v-model="form.contactdata.email"
        type="email"
        autocomplete="email"
        label="E-Mail"
        large
        :test-id="getTestId('end-step-email')"
      />
    </div>

    <template v-if="form.meta.is_patient">
      <ComponentTextarea
        v-model="form.additional"
        large
        label="Möchten Sie sonst noch etwas mitteilen?"
        :maxlength="500"
        :test-id="getTestId('end-step-additional')"
      />
    </template>

    <template v-else>
      <p>Sie können den Fragebogen nun absenden.</p>
    </template>

    <div class="text-right">* Pflichtangaben</div>

    <template #navigation>
      <MedButton
        class="flex-1 sm:order-2"
        variant="primary"
        :is-loading="form.processing"
        :disabled="!allFieldsValid"
        :data-test="getTestId('end-step-processing-button')"
        @click="$emit('navigate', 'submit')"
      >
        Absenden
      </MedButton>

      <MedButton class="flex-1" :data-test="getTestId('end-step-back-button')" @click="$emit('navigate', '-')">
        Zurück
      </MedButton>
    </template>

    <template #bottom>
      <p>Ihre Angaben werden sicher Ende-zu-Ende verschlüsselt übertragen.</p>
    </template>
  </PatientinputComponentStep>
</template>
